var a=function(a,n){return a?(a.forEach((function(a){a.disabled=a.disabled||n})),a):[]};export{a as p};
//# sourceMappingURL=index-77c94362.js.map
